import { Deserializable } from "./deserializable";
import { Order } from "./order";
import {PendingOrderView} from "../api";

export class AppSalesState implements Deserializable <AppSalesState> {

  deserialize(input: any) : AppSalesState {
    Object.assign(this, input);
    return this;
  }

  public selectedCustomer;
  public order : PendingOrderView;

  public renewalSourceOrderId?: number;
  public renewalPendingOrderId?: number;
  public renewalPayByInvoice?: boolean;
  public renewalReference?: string;
}

